import * as Vue from 'vue'
import * as VueRouter from 'vue-router'
import Layout from '../layout/index.vue'
import bbwSite from "@/api/bbw/bbwSite";

const routes = [
    {
        path: '',
        component: Layout,
        redirect: '/index', // 使用相对路径来重定向
        children: [
            {
                path: 'index',
                component: Vue.defineAsyncComponent({
                    loader: () => import('@/views/home'),

                    delay: 200, // 延迟 200ms 显示 loading
                    timeout: 3000, // 超过 3 秒不加载则显示错误提示
                }),
                name: 'Index',
                meta: { title: '首页', icon: 'home' },
            },
            {
                path: 'info/:column',
                component: Vue.defineAsyncComponent({
                    loader: () => import('@/views/news/list.vue'),

                    delay: 200,
                    timeout: 3000,
                }),
                name: 'Info',
                meta: { title: '信息列表', icon: 'info' },
            },
            {
                path: 'detail/:id/:column',
                component: Vue.defineAsyncComponent({
                    loader: () => import('@/views/news/detail.vue'),

                    delay: 200,
                    timeout: 3000,
                }),
                name: 'Detail',
                meta: { noSearch: true, title: '新闻详情' },
            },
            {
                path: 'introduce/:column',
                component: Vue.defineAsyncComponent({
                    loader: () => import('@/views/introduce/index.vue'),

                    delay: 200,
                    timeout: 3000,
                }),
                name: 'Introduce',
                meta: { title: '公司介绍', icon: 'info-circle' },
            },
            {
                path: 'purchase/list/',
                component: Vue.defineAsyncComponent({
                    loader: () => import('@/views/purchase/list/index.vue'),

                    delay: 200,
                    timeout: 3000,
                }),
                name: 'PurchaseList',
                meta: { noSearch: true, title: '采购列表' },
            },
            {
                path: 'purchase/detail/',
                component: Vue.defineAsyncComponent({
                    loader: () => import('@/views/purchase/detail/index.vue'),

                    delay: 200,
                    timeout: 3000,
                }),
                name: 'PurchaseDetail',
                meta: { noSearch: true, title: '采购详情' },
            },
            {
                path: 'front/content/:id',
                component: Vue.defineAsyncComponent({
                    loader: () => import("@/views/news/preview.vue"),

                    delay: 200,
                    timeout: 3000,
                }),
                name: 'NewPreview',
                meta: { noSearch: true, title: '新闻预览' },
            }
        ],
    },
]

const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory(),
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { top: 0 };
    },
})

router.afterEach((to) => {
    // 修改页面标题
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }

    // 记录访问日志
    if (to.name && (to.name !== 'Detail' || to.name !== 'PurchaseDetail')) {
        bbwSite.accessRecordParse(to.name);  // 假设 bbwSite 是你自定义的记录访问的工具
    }
})

export default router
